<template>
    <Field :name="name" v-slot="{ field, errors, validate }" v-bind="fieldValidateOn">
        <Textbox
            v-model="field.value"
            @update:modelValue="field['onUpdate:modelValue']"
            @change="field.onChange"
            @blur="(e: Event) => handleOnBlur(e, field, validate)"
            @input="field.onInput"
            :errorMessages="errors.concat(customErrors)"
            :field-error="!isEmpty(errors.concat(customErrors))"
            v-bind="input" />
    </Field>
</template>

<script lang="ts">
    import { PropType, ExtractPropTypes, defineComponent, inject } from 'vue';
    import { FieldValidateOn } from '../../Validations/Validations.interfaces';
    import { Field, FieldBindingObject, FieldValidator } from 'vee-validate';
    import { isEmpty } from 'lodash';
    import Textbox from './Textbox.vue';

    type TextboxProps = ExtractPropTypes<typeof Textbox.props>;

    export default defineComponent({
        name: 'TextboxField',
        methods: { isEmpty },
        components: { Field, Textbox },
        props: {
            name: {
                type: String,
                required: true,
            },
            input: {
                type: Object as PropType<Partial<TextboxProps>>,
                default: () => ({}),
            },
            customErrors: {
                type: Array as PropType<string[]>,
                default: () => [],
            },
            onBlurSuccess: {
                type: Function as PropType<(value: any) => void>,
            },
        },
        setup(props) {
            const fieldValidateOn = inject('fieldValidateOn') as FieldValidateOn;

            const handleOnBlur = (
                e: Event,
                field: FieldBindingObject<any>,
                validate: FieldValidator<unknown>
            ) => {
                field.onBlur(e);
                if (props.onBlurSuccess) {
                    validate().then(({ valid }) => {
                        const isValid = valid && isEmpty(props.customErrors);
                        if (isValid && props.onBlurSuccess) {
                            props.onBlurSuccess(field.value);
                        }
                    });
                }
            };

            return { fieldValidateOn, handleOnBlur };
        },
    });
</script>
